import React from 'react';

const WhyDifferent = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center relative">
            Por que este trabalho é diferente?
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-red-600 mt-2"></span>
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-red-600 mb-6">O que NÃO é:</h3>
              
              <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-gray-400">
                <h4 className="font-bold mb-3 text-gray-700">❌ Terapia tradicional de consultório</h4>
                <p className="text-gray-600">
                  Não se limita a sessões semanais convencionais ou abordagens padronizadas que tratam apenas sintomas superficiais.
                </p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-gray-400">
                <h4 className="font-bold mb-3 text-gray-700">❌ Coaching motivacional superficial</h4>
                <p className="text-gray-600">
                  Não oferece fórmulas mágicas, mantras motivacionais ou promessas de mudanças instantâneas sem fundamento científico.
                </p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-gray-400">
                <h4 className="font-bold mb-3 text-gray-700">❌ Resultados mágicos em 30 dias</h4>
                <p className="text-gray-600">
                  Não promete transformações irreais ou soluções rápidas para questões emocionais complexas que levaram anos para se formar.
                </p>
              </div>
            </div>
            
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-red-600 mb-6">O que É:</h3>
              
              <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-600">
                <h4 className="font-bold mb-3 text-black">✓ Processo científico de reconstrução profunda</h4>
                <p className="text-gray-700">
                  Integração de Psicanálise, Análise Comportamental e PNL para abordar as raízes inconscientes dos padrões emocionais.
                </p>
              </div>
              
              <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-600">
                <h4 className="font-bold mb-3 text-black">✓ Abordagem humanizada e ética</h4>
                <p className="text-gray-700">
                  Trabalho personalizado que respeita seu tempo, suas limitações e sua singularidade, sem julgamentos ou pressões.
                </p>
              </div>
              
              <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-600">
                <h4 className="font-bold mb-3 text-black">✓ Resultados duradouros e sustentáveis</h4>
                <p className="text-gray-700">
                  Foco na reconstrução da identidade emocional para mudanças que se mantêm ao longo da vida, não apenas alívios temporários.
                </p>
              </div>
            </div>
          </div>
          
          <div className="text-center bg-black text-white p-8 rounded-lg">
            <h3 className="text-2xl font-bold mb-4">
              A diferença está na profundidade
            </h3>
            <p className="text-xl text-gray-300 mb-6">
              "Não se trata de motivação temporária, mas de libertação permanente dos padrões que aprisionam sua mente."
            </p>
            <p className="text-lg font-medium text-red-400">
              — Kelton Oliveira
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDifferent;

